import Icon from "@web-ui/components/Icon";
import type { Tone } from "@web-ui/types/tone";

/*
 * IconDisc: a kit icon in a round tinted disc, the leading visual of a list row, a stat tile or an empty
 * state (owner 2026-10-13; the apps drew it eight ways). Neutral is the quiet surface with the secondary
 * ink; any other tone tints the disc and inks the glyph in it. Decorative (the icon is aria-hidden): the
 * row's words carry the meaning. Styles in styles/data-display.css .icon-disc.
 */
type IconDiscProps = {
    className?: string;
    tone: Tone;
    icon: string;
    /** sm 32px (a stat tile), md 44px (a list row, the default), lg 56px (an empty state). */
    size?: "sm" | "md" | "lg";
};

const GLYPH = { sm: 4, md: 6, lg: 6 } as const;

const IconDisc = ({ className, tone, icon, size = "md" }: IconDiscProps) => (
    <span className={`icon-disc ${size === "md" ? "" : `icon-disc--${size}`} ${className || ""}`} data-tone={tone}>
        <Icon name={icon} size={GLYPH[size]} />
    </span>
);

export default IconDisc;
